var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelekomLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#E20074"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 30) scale(0.85) translate(-30 -30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5763 36.1H14V28.5H21.5763V36.1ZM14 11V23.9H16.2928V23.5C16.2928 17.4 19.6822 13.6 26.162 13.6H26.5607V41C26.5607 44.8 25.0654 46.3 21.2773 46.3H20.081V49H39.8193V46.3H38.7227C34.9346 46.3 33.4393 44.8 33.4393 41V13.7H33.838C40.3178 13.7 43.7072 17.5 43.7072 23.6V24H46V11L14 11ZM38.2243 36.1H45.8006V28.5H38.2243V36.1Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelekomLogo);
export default __webpack_public_path__ + "static/media/telekom-logo.bd178c338f7735502297b6c2cf63026b.svg";
export { ForwardRef as ReactComponent };